import { graphql, useStaticQuery } from 'gatsby';

import { IPage, IParentPage } from '../../types/shared';

import { getInternalLink } from './linkGenerator';

interface ProductsToExclude {
  name: string;
  url: string;
  path: string;
}

export const getProductLink = (
  productLinkPath: string,
  defaultLink: string,
  defaultLinkType = 'internal'
) => {
  const data = useStaticQuery(graphql`
    query StaticProductsQuery {
      allProductsJson(filter: { name: { ne: null } }) {
        nodes {
          name
          url
          path
        }
      }
    }
  `);

  const staticExternalLinks = data.allProductsJson.nodes as ProductsToExclude[];

  const foundPath = staticExternalLinks.find(({ path }) => {
    return productLinkPath.includes(`${path}`);
  });
  if (foundPath) return [foundPath.url, 'external'];
  return [defaultLink, defaultLinkType];
};

const getProductLinkFromPage = (page: IPage) => {
  const internalLink = getInternalLink(page as IParentPage);
  const urlAfterSlash = internalLink.substring(internalLink.indexOf('/'));
  return getProductLink(urlAfterSlash, `/${internalLink}`);
};

const getProductLinkFromUrl = (
  pageUrl: string,
  defaultLinkType = 'internal'
) => {
  const urlAfterSlash = pageUrl.substring(pageUrl.indexOf('/'));
  return getProductLink(urlAfterSlash, pageUrl, defaultLinkType);
};

export { getProductLinkFromPage, getProductLinkFromUrl };
